// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
import config from '../assets/empresas/molina_tours/configuraciones/config.json';
import configuration from '../assets/empresas/configuraciones/configuration.json';

export const environment = {
  production: false,
  URL_BASE: 'https://molinatours.fyranova.com/integration-produccion/api/',
  //URL_BASE: 'https://molinatours.nexusvirtual.net/integration-test/api/',
  // URL_BASE: 'http://localhost/integration-test/api/',
  URL_PAYU: 'https://molinatours.nexusvirtual.net/ServicioPayu/api/',
  URL_VISANET: 'https://directo.nexusvirtual.net/PASARELA_VISA/api/',
  URL_CONDUCTOR: '',
  URL_INTRANET: 'https://molinatours.nexusvirtual.net/intranet/',
  URL_REPORTE:
    'https://reporte-molinatours.nexusvirtual.net/reporte-molinatours/', //'https://reportes-docker.nexusvirtual.net/molinaTours/',
  URL_TRACKING:
    'https://reportes-docker.nexusvirtual.net/molinatours-tracking/',
  VERSION: 'Versión 2.0.0',
  IDIOMA: 'es',
  versionCheckURL: 'http://<<your url>>/version.json',
  NAME_COMPANY: 'molina_tours',
  LOGO_LOGIN: {
      URL: 'assets/empresas/molina_tours/img/logos/logo-molina-tours-no-bg.png',
      ALT: 'logo-molina_tours'
  },
  LOGO: {
    URL: 'assets/empresas/molina_tours/img/logos/logo-molina-tours-menu.png',
    ALT: 'logo-molina_tours',
    WIDTH: 120,
  },
  LOGO_MENU: {
    FLAG: false,
    URL: '',
    ALT: 'logo-level',
    WIDTH: 120,
  },
  LOGO_INICIO_SESION: {
    URL: 'assets/empresas/molina_tours/img/logos/logo-empresa.jpg',
    ALT: 'logo-molina_tours',
  },
  COLOR_RUTA: '#008efb',
  COLOR_RUTA_CONDUCTOR: '#008efb',
  COLOR: {
    PRIMARY: '#00529C',
    SECONDARY: '#f58721',
    KM: '#ffffff',
    TEXT: "#EF494D"
  },
  RECAPCHA: {
    SITEKEY: '',
  },
  IMAGEN_USUARIO_URL: 'assets/usuario.png',
  ICON_BUSQUEDA: {
    ORIGEN: {
      URL: 'assets/empresas/molina_tours/img/busqueda/origen.svg',
      ALT: 'imagen-origen',
    },
    DESTINO: {
      URL: 'assets/empresas/molina_tours/img/busqueda/destino.svg',
      ALT: 'imagen-destino',
    },
    ORIGENTRACKING: {
      URL: 'assets/empresas/LEVEL_TAXI/img/markers/marker-origen.png',
      POSICION: 1,
      ICON_SIZE: new google.maps.Size(56, 56),
    },
    DESTINOTRACKING: {
      URL: 'assets/empresas/LEVEL_TAXI/img/markers/marker-destino.png',
      POSICION: 2,
      ICON_SIZE: new google.maps.Size(56, 56),
    },
    REFERENCIA: {
      URL: 'assets/empresas/movicab/img/markers/referencia.png',
      ALT: 'imagen-referencia',
    },
    INSTRUCCION: {
      URL: 'assets/empresas/movicab/img/markers/instruccion.png',
      ALT: 'imagen-instruccion',
    },
    ICONO_TIEMPO: {
      URL: 'assets/atras-en-el-tiempo.svg',
      ALT: 'imagen-tiempo',
    },
    ICON_LOCALTION: {
      URL: 'assets/location.svg',
      ALT: 'imagen-tiempo'
    },
  },
  TEST: 'assets/empresas/molina_tours/img/busqueda/destino.png',
  MARKERS: {
    ORIGEN: {
      URL: 'assets/empresas/molina_tours/img/markers/origen.svg',
      POSICION: 1,
      ICON_SIZE: new google.maps.Size(56, 56),
    },
    DESTINO: {
      URL: 'assets/empresas/molina_tours/img/markers/destino.svg',
      URL_1: 'marker-destino.svg',
      URL_2: 'marker-destino.svg',
      URL_3: 'marker-destino.svg',
      URL_4: 'marker-destino.svg',
      URL_5: 'marker-destino.svg',
      URL_6: 'marker-destino.svg',
      URL_7: 'marker-destino.svg',
      URL_9: 'marker-destino.svg',
      POSICION: 2,
      ICON_SIZE: new google.maps.Size(56, 56),
    },
    ORIGENTRACKING: {
      URL: 'assets/empresas/LEVEL_TAXI/img/markers/marker-origen.png',
      POSICION: 1,
      ICON_SIZE: new google.maps.Size(56, 56),
    },
    DESTINOTRACKING: {
      URL: 'assets/empresas/LEVEL_TAXI/img/markers/marker-destino.png',
      POSICION: 2,
      ICON_SIZE: new google.maps.Size(56, 56),
    },

    TRAYECTO: {
      URL: 'assets/empresas/molina_tours/img/markers/punto.png',
      POSICION: 3,
      ICON_SIZE: new google.maps.Size(20, 20),
    },

    CONTACTO: {
      URL: 'assets/empresas/molina_tours/img/markers/simple_Icon.png',
      POSICION: 2,
      ICON_SIZE: new google.maps.Size(56, 56),
    },
    VELOCIDAD: {
      URL: 'assets/empresas/bym_taxi/img/markers/pin.png',
      POSICION: 2,
      ICON_SIZE: new google.maps.Size(56, 56),
    },
    CONDUCTOR: {
      URL: 'assets/empresas/molina_tours/img/markers/conductor.png',
      POSICION: 3,
      ICON_SIZE: new google.maps.Size(56, 56),
    },
    CONDUCTOR_AUTO_LIBRE: {
      URL: 'assets/empresas/molina_tours/img/markers/marker_verde.png',
      POSICION: 3,
      ICON_SIZE: new google.maps.Size(48, 48),
    },
    CONDUCTOR_AUTO_SINGPS: {
      URL: 'assets/empresas/molina_tours/img/markers/marker_gris.png',
      POSICION: 3,
      ICON_SIZE: new google.maps.Size(48, 48),
    },
    CONDUCTOR_AUTO_OCUPADO: {
      URL: 'assets/empresas/molina_tours/img/markers/marker_rojo.png',
      POSICION: 3,
      ICON_SIZE: new google.maps.Size(48, 48),
    },
    CONDUCTOR_MOTO_LIBRE: {
      URL: 'assets/empresas/cargui/img/markers/marker_verde.png',
      POSICION: 3,
      ICON_SIZE: new google.maps.Size(48, 48),
    },
    CONDUCTOR_MOTO_SINGPS: {
      URL: 'assets/empresas/cargui/img/markers/marker_gris.png',
      POSICION: 3,
      ICON_SIZE: new google.maps.Size(48, 48),
    },
    CONDUCTOR_MOTO_OCUPADO: {
      URL: 'assets/empresas/cargui/img/markers/marker_rojo.png',
      POSICION: 3,
      ICON_SIZE: new google.maps.Size(48, 48),
    },
    DRIVER: {
      CARRO_DEFECTO: {
        URL: 'assets/empresas/LEVEL_TAXI/img/markers/ic_driver_top.png',
        POSICION: 3,
        ICON_SIZE: new google.maps.Size(30, 30),
      },
      MOTO: {
        URL: 'assets/empresas/cargui/img/tipo-autos/moto.svg',
        POSICION: 3,
        ICON_SIZE: new google.maps.Size(30, 30),
      },
      AUTO: {
        URL: 'assets/empresas/cargui/img/tipo-autos/auto.svg',
        POSICION: 3,
        ICON_SIZE: new google.maps.Size(30, 30),
      },
      MINIVAN: {
        URL: 'assets/empresas/cargui/img/tipo-autos/minivan.svg',
        POSICION: 3,
        ICON_SIZE: new google.maps.Size(30, 30),
      },
      CAMIONETA: {
        URL: 'assets/empresas/cargui/img/tipo-autos/camioneta.svg',
        POSICION: 3,
        ICON_SIZE: new google.maps.Size(30, 30),
      },
      STATION_WAGON: {
        URL: 'assets/empresas/cargui/img/tipo-autos/station-wagon.svg',
        POSICION: 3,
        ICON_SIZE: new google.maps.Size(30, 30),
      },
    },
    CUSTOM: {
      URL: 'assets/img/markers/marker-custom.png',
      POSICION: 3,
      ICON_SIZE: new google.maps.Size(40, 40)
    }
  },
  ICONO_TIPO_SERVICIO: {
    URL_FURGONET: '',
    URL_CAMIONETA: '',
    URL_AUTO: '',
  },
  IMAGEN_SESION_1: {
    URL: 'assets/empresas/senior-taxi/img/logos/imagen-logo-1.png',
    ALT: 'img-senñor-taxi',
  },
  IMAGEN_SESION_2: {
    URL: 'assets/empresas/senior-taxi/img/logos/imagen-logo-2-png',
    ALT: 'img-senñor-taxi',
  },
  IMAGEN_CANDADO: {
    URL: 'assets/empresas/molina_tours/img/logos/reset-password.png',
    ALT: 'img-lock',
  },
  ESTADO: {
    ASIGNADO: 2,
    LEIDO: 3,
    CONTACTO: 5,
    INICIO: 6,
    TERMINADO: 7,
    LLEGO_DESTINO: 14,
    CANCELADO: 10,
    LIBRE: 1,
    PENDIENTE: 12,
    RECHAZADO: 9,
    OCUPADO: 15,
    FIN_JORNADA: 13,
    PREASIGNADO: 16,
    ANULADO1: 8,
    ANULADO2: 9,
    ANULADO3: 10,
    SIN_SENIAL: -1,
  },
  MODO_RESERVA: {
    BASE: 1,
    APLICATIVO: 2,
    WEB_API: 3,
    WEB: 4,
    COMUNIDAD: 5,
    IVR: 7,
    CORREO: 8,
  },
  TIPO_PAGO: {
    VALE: 1,
    EFECTIVO: 2,
    ABONO: 4,
    E_VALE: 6,
    TARJETA: 7,
    CORTESIA: 20,
    TIKECK_COUNTER: 21,
  },
  TIPO_SERVICIO: {
    MOTO: 10,
    POR_TIEMPO: 5,
  },
  TIEMPO_CONSULTAR_RUTA: 10000,
  MENSAJES: {
    CAMPOS_DINAMICOS: {
      NO_INGRESADOS: 'Necesario ingresar Campos Dinámicos',
    },
    KILOMETRAJE: {
      NO_CALCULADO: 'No se ha calculado la cantidad de kilómetros',
    },
    CONFIGURACION_PARAMETROS: {
      MSJ_ACTUALIZACION: 'Su información se actualizo correctamente',
      MSJ_NO_EXISTE_PARAMETRO: ' No existe el parámetro: ',
    },
    COMPARTIR_SERVICIO: {
      MSJ_SERVICIO_NO_ENCONTRADO: 'NO SE ENCONTRÓ EL SERVICIO.',
      MSJ_SERVICIO_LIBRE: 'Servicio creado',
      MSJ_SERVICIO_ASIGNADO: 'su conductor está en camino',
      MSJ_SERVICIO_INICIO: 'está en camino',
      MSJ_SERVICIO_TERMINO: 'Llegó a su destino',
    },
    SOLICITAR_SERVICIO: {
      MSJ_SERVICIO_CREADO: 'Servicio creado correctamente.',
      MSJ_ERROR_DESCONOCIDO:
        'Ocurrio un problema, por favor intente nuevamente.',
      MSJ_SIN_PRESUPUESTO: 'No cuenta con Presupuesto.',
      MSJ_VALIDACION_HORARIO:
        'No se puede realizar el servicio en el horario indicado.',
      MSJ_PRESUPUESTO_INACTIVO:
        'Presupuesto inactivo, elegir otro tipo de pago.',
      MSJ_EMPRESA_INACTIVA: 'Empresa inactiva.',
      MSJ_EMPRESA_PRESUPUESTO_INACTIVO: 'Empresa - Presupuesto Inactivo.',
      MSJ_CENTRO_COSTO_INACTIVO: 'Centro Costo Inactivo.',
      MSJ_CENTRO_COSTO_PRESUPUESTO_INACTIVO:
        'Centro Costo - Presupuesto Inactivo.',
      MSJ_PRESUPUESTO_INACTIVO_CLIENTE: 'Cliente - Presupuesto Inactivo.',
      MSJ_PRESUPUESTO_PLAZO_INCORRECTO:
        'El plazo solicitado es incorrecto, máximo 2 días de anticipación.',
      MSJ_NOTA_OBLIGATORIA: 'El campo Nota 1 es obligatirio.',
      MSJ_USUARIO_NO_ENCONTRADO: 'No se encontraron usuarios',
      MSJ_EMPRESA_NO_ENCONTRADA: 'No se encontraron Empresas',
      MSJ_CC_NO_ENCONTRADO: 'No se encontraron Centros de Costos',
      MSJ_ZONAS_NO_ENCONTRADA: 'No se encontraron Zonas de tiempo de reserva',
      MSJ_AREAS_NO_ENCONTRADA: 'No se encontraron Áreas o Subáreas',
      MSJ_TRACKING_NO_ENCONTRADO: 'No se encontró el tracking del conductor',
      MSJ_CUPONES_NO_ENCONTRADO: 'No se encontró registro de cupones.',
      MSJ_PEV_NO_ENCONTRADO: 'No se encontró registros',
      MSJ_AGREGAR_TARJETA:
        'NO DISPONE DE UNA TARJETA, AGREGUE PARA PEDIR UNA ORDEN',
    },
    CANCELAR_SERVICIO: {
      MSJ_CANCELAR_SERVICIO: 'Búsqueda cancelada por usuario.',
      MSJ_CANCELAR_SERVICIO_ENVIOS: 'El servicio fue cancelado correctamente.',
    },
    SEDES: {
      MSJ_SEDE_NO_ENCONTRADA: 'No se encontraron Sedes',
    },
    DIRECCION_FAVORITA: {
      DIRECCION_GUARDADA: 'Se agregó la dirección favorita exitosamente',
      DIRECCION_NO_GUARDADA:
        'No se ha logrado guardar la dirección exitosamente',
      DIRECCION_AÑADIDA: 'Se añadió a la ruta la dirección favorita',
      DIRECCION_BORRADA: 'Se eliminó la dirección favorita correctamente',
      DIRECCION_ENBLACO: 'No has ingresado ninguna dirección en el campo',
      NOMBREFAVORITO_ENBLANCO:
        'No has ingresado un nombre para tu dirección favorita',
    },
    FORMULARIO_CONDUCTOR: {
      OK_MESSAGE: 'Registro Exitoso!',
      WARNING_MESSAGE_CAMPO_MOTIVO: 'Seleccione una sede',
      WARNING_MESSAGE_CAMPO_TIENDA: 'Seleccione una empresa',
      LABEL_BUTTON_ATRAS: 'Atrás',
      LABEL_BUTTON_ACEPTAR: 'Aceptar',
    },
    LOGIN: {
      USUARIO_INACTIVO: {
        CODIGO: -201,
        DESCRIPCION: 'Usuario inactivo',
      },
      NO_EXISTE_USUARIO: {
        CODIGO: -203,
        DESCRIPCION: 'No existe usuario',
      },
      CLAVE_INCORRECTA: {
        CODIGO: -202,
        DESCRIPCION: 'Contraseña incorrecta',
      },

      CLAVE_NO_ESTABLECIDA: {
        CODIGO: -204,
        DESCRIPCION: 'Contraseña no establecida',
      },
      ERROR: {
        CODIGO: -1,
        DESCRIPCION: 'Ocurrio un error',
      },
      CORREO_CORPORATIVO: {
        CODIGO: 1,
        DESCRIPCION:
          'Correo enviado correctamente. Por favor revise su bandeja de entrada',
      },
      RECUPERAR_CONTRASENIA: {
        CODIGO: 1,
        DESCRIPCION:
          'Recibiras en unos momentos un mensaje a su correo electrónico, indicando su contraseña.',
      },
      CORREO_DUPLICADO: {
        CODIGO: -6,
        DESCRIPCION: 'Su correo ya ha sido registrado',
      },
      CORREO_SIN_ACCESOS: {
        CODIGO: -999,
        DESCRIPCION: 'Usted no tiene accesos a la web',
      },
      USUARIO_NO_RELACIONADO: {
        CODIGO: -206,
        DESCRIPCION: 'Usted no está relacionado a la empresa',
      },
      USUARIO_NO_ASIGNADO: {
        CODIGO: -207,
        DESCRIPCION: 'Usted no tiene asignado una empresa',
      },
    },

    ENVIOS: {
      MSJ_SIN_CONDUCTOR: 'No se pudo obtener coordenadas del conductor.',
      MSJ_SIN_SERVICIOS: 'No se encontraron servicios',
      MSJ_CALIFICACION_ESTRELLAS: 'Se calificó correctamente al conductor.',
      MSJ_SERVICIOS_POR_CALIFICAR:
        "Tienes servicios por calificar, puede realizarlo desde 'Ver servicios'.",
      ERROR: {
        ERROR_CALIFICACION_ESTRELLAS:
          'Ocurrió un error al calificar; por favor intente mas tarde.',
      },
    },
    OCURRIO_PROBLEMA: {
      CODIGO: -1,
      DESCRIPCION: 'Ocurrio un problema, por favor intente nuevamente.',
    },
    METODO_PAGO: {
      TARJETA_CREADA: 'Se ha registrado su tarjeta correctamente',
    },
    PROMOCIONES: 'Validación exitosa',
    SERVICIOS_ENVIADOS: 'Servicios enviados correctamente',
    ZONA_PELIGROSA:
      'Recojo en zona con Alta Siniestralidad por Robo reportada por las autoridades. Un operador lo llamará minutos antes del servicio para coordinar un recojo seguro.',
    FORMAT_EXCEL: 'EL Formato Excel es Incorrecto',
  },
  PROVIDER: {
    CULQI: 1,
    PAYU: 0,
    VISANET: 3,
  },
  ROL: {
    ADMIN: 1,
    PARTICULAR: 3,
    ADMIN_CORPORATIVO: 5,
    CORPORATIVO: 6,
    ASISTENTE_CORPORATIVO: 15,
    SUPERVISOR: 13,
    DIGITACION: 26,
    OWNER: -2,
    MANAGER: 17,
  },
  SOLICITAR_MULTIPUNTO: {
    MSJ_CLEAR_RUTA:
      'Solicitar Servicio: No  ha ingresado los campos requeridos.',
    MSJ_LISTA_MARKERS_VACIA: 'No ha ingresado el dato de destino.',
    MSJ_USUARIO_TELEFONO: 'Ingrese un numero telefono.',
    MSJ_TIPO_PAGO: 'Seleccione un tipo de pago.',
    MSJ_DETALLE_ENVIO: 'Describa su envio.',
    MSJ_CONTACTO_NOMBRE: 'Ingrese el nombre del contacto.',
    MSJ_CONTACTO_TELEFONO: 'Ingrese el telefono del contacto.',
    MSJ_NO_OBTUVO_CONDUCTOR: 'No se encontro conductor.',
    MSJ_MINIMO_LENGTH: 'Numero de celular Incorrecto.',
    MSJ_REGISTER_TARJETA: 'Su tarjeta ha sido registrada exitosamente',
    MSJ_REGISTRAR_TARJETA:
      'Por favor espere unos minutos mientras se registra su tarjeta',
    MSJ_TIPO_SERVICIO: 'Seleccione un tipo de servicio.',
    MSJ_ID_PASAJERO: 'Seleccione un personal de la empresa.',
    MSJ_TELEFONO_PASAJERO: 'Ingrese un celular del personal de la empresa.',
    MSJ_LINEA_AEREA: 'Ingrese la línea aérea.',
    MSJ_NRO_VUELO: 'Ingrese el numero de vuelo.',
    MJ_LISTA_PERSONAL:
      'Espere un momento, la lista de personal se esta cargando.',
    MSJ_NO_PERSONAL: 'No se encuentran resultados.',
    MSJ_NO_HA_SELECCIONADO_FECHAS:
      'Seleccione fecha para el servicio de rutina',
    MSJ_NO_INGRESO_CAMPOS_DINAMICOS:
      'El dato de los campos dinamicos requeridos aun no ha sido ingresado',
    MSJ_NO_CENTRO_COSTO: 'No se seleccionó un Centro de Costo',
    ERROR: {
      USUARIO_INACTIVO: 'El usuario esta inactivo',
      CONSURTAR_TARIFA: 'Ocurrio un error, Por favor intente mas tarde.',
      CREAR_SERVICIO:
        'Ocurrio un error, Por favor cree un servicio nuevamente.',
      OBTENER_CONDUCTOR:
        'Ocurrio un error, Por favor volver a realizar la consulta.',
      CANCELAR_SERVICIO: 'Ocurrio un error, No se pudo cancelar el servicio.',
      TIPO_PAGO: 'Ocurrio un error, Por favor recargar la pagina.',
      TIPO_PAGO_EMPTY: 'Usted no tiene ningun tipo de pago registrado.',
      TIPO_SERVICIO_EMPTY: 'Usted no tiene ningun tipo de servicio registrado.',
      LST_PERSONAL: 'Ocurrio un error, Al cargar la lista del personal.',
      LST_SEDES: 'Ocurrio un error, Al cargar la lista las Sedes',
      LST_CENTRO_COSTO_EDITABLE:
        'Ocurrio un error, Al cargar los Centros de Costos.',
      SIN_PRESUPUESTO: 'No cuenta con Presupuesto',
      SIN_DIRECCION: 'No se encontro la dirección ingresada',
      VALIDACION_HORARIO:
        'No se puede realizar el servicio en el horario indicado',
      PRESUPUESTO_INACTIVO: 'Presupuesto inactivo, elegir otro tipo de pago',
      EMPRESA_INACTIVA: 'Empresa inactiva',
      EMPRESA_PRESUPUESTO_INACTIVO: 'Empresa - Presupuesto Inactivo',
      CENTRO_COSTO_INACTIVO: 'Centro Costo Inactivo',
      CENTRO_COSTO_PRESUPUESTO_INACTIVO: 'Centro costo - Presupuesto Inactivo',
      PRESUPUESTO_INACTIVO_CLIENTE: 'Cliente - Presupuesto Inactivo',
      SIN_TARIFA: 'No se pudo obtener la tarifa para la ruta ingresada',
      SERVICIO_FECHA_RESERVA_MINIMA:
        'La fecha seleccionada no cumple con el tiempo minimo de reserva. ',
      PRESUPUESTO_PLAZO_INCORRECTO:
        'El plazo solicitado es incorrecto, máximo 2 días de anticipación',
      NOTA_OBLIGATORIA: 'El campo Nota 1 es obligatorio',
      ERROR_RUTINA_SERVICIOS:
        'Hubo un inconveniente al crear los servicios, con las fechas: ',
      ERROR_CONDUCTORES_CERCANOS:
        'Ocurrio un error al obtener conductores cercanos, Por favor intente mas tarde.',
    },
  },
  TIPO_EMAIL: {
    NINGUNO: 0,
    NUEVO_CLIENTE: 1,
    FIN_SERVICIO: 2,
    RECUPERAR_CONTRASENIA: 4,
  },
  ENVIOS: {
    HABILITAR_TRAZADO: false,
    CONSULTA_ENVIOS: 10000,
    FLAG_LABEL_TELEFONO_CONDUCTOR: true, // solo movicab false
    ACTIVAR_TIEMPO_LLEGADA_CONDUCTOR: false, // true directo y cargui
    ACTIVAR_TIEMPO_RUTA: false, // solo para cargui
    TIEMPO_LLEGADA_CONDUCTOR: false, // solo cargui
  },
  COMPARTIR_SERVICIO: {
    HABILITAR_TRAZADO: true,
    HABILITAR_TRAZADO_CONDUCTOR: false, //true solo directo
    HABILITAR_DETALLE:false,
    DISTANCIA_CONDUCTOR:false,
    HABILITAR_DIRECCIONES: false
  },
  MENU: {
    SOLICITAR_SERVICIO: 1,
    USUARIOS: 2,
    ENVIOS: 3,
    METODOS_PAGO: 4,
    MI_EMPRESA: 5,
    MI_CUENTA: 6,
    CERRAR_SESION: 7,
    CENTRO_COSTO: 8,
  },
  URL_TIENDA: {
    ANDROID:
      'https://play.google.com/store/apps/details?id=com.nexusvirtual.client.leveltaxi',
    IMG_ANDRIOD: '',
    IOS: 'https://itunes.apple.com/pe/app/level-taxi-cliente/id1117497500?l=en',
    IMG_IOS: '',
  },
  APPIDFB: '310329426412429',
  INICIO_FB: false,
  FOTO_ESTRELLA: 'assets/estrellaConductor.png',
  API_KEY_GOOGLE: 'AIzaSyBrcFOAzAD8JZgBYrzLdHFhyWJ8o8dlcSs',
  OPTIMIZEWAYPOINTS: false,
  SHOWPOLIGONO: false,
  MULTIDESTINO: true,
  EMPRESA: {
    PARTICULAR: 1,
  },
  CENTRO_COSTO: {
    PARTICULAR: 1425,
  },
  CENTRO_COSTO_TERCERO: {
    ACTIVO: false, //true solo para ctg
  },
  OPCIONES_DESARROLLO: true,
  CODIGO_PROMOCIONAL: {
    MONEDA_LOCAL: 1,
    PORCENTAJE: 2,
  },
  COUNTRY_DEV: {
    HABILITADO: false,
    PAISES: {
      BOLIVIA: {
        HABILITADO: false,
        COORD: {
          LAT: -17.787699,
          LNG: -63.18527,
        },
        CODE: 'BO',
      },
      CHILE: {
        HABILITADO: false,
        COORD: {
          LAT: -33.431866,
          LNG: -70.609325,
        },
        CODE: 'CL',
      },
      MEXICO: {
        HABILITADO: true,
        COORD: {
          LAT: 19.1788445,
          LNG: -96.2113356,
        },
        CODE: 'MX',
      },
      COSTA_RICA: {
        HABILITADO: true,
        COORD: {
          LAT: 9.935697,
          LNG: -84.1484506,
        },
        CODE: 'CR',
      },
      EC: {
        HABILITADO: true,
        COORD: {
          LAT: -2.1662649,
          LNG: -79.921618,
        },
        CODE: 'EC',
      },
      PERU: {
        HABILITADO: false,
        COORD: {
          LAT: -12.064075,
          LNG: -77.012692
        },
        CODE: 'PE'
      }
    },
  },
  CONF_PAIS: {
    PAISES: {
      BOLIVIA: {
        RUC: 'NIT',
        DNI: 'C.I. (Cédula de identidad)',
        REFERENCIA: 'Añada un Psj, Dpto, interior, piso, Mz Lt',
        CODE: 'BO',
      },
      CHILE: {
        RUC: 'RUT',
        REFERENCIA: 'Calle y número, Oficina / Piso, Comuna ,Ciudad',

        CODE: 'CL',
      },
      PERU: {
        RUC: 'RUC',
        DNI: 'DNI',
        REFERENCIA: 'Añada un Psj, Dpto, interior, piso, Mz Lt',
        CODE: 'PE',
      },
      MEXICO: {
        RUC: 'RFC',
        DNI: 'INE',
        REFERENCIA: 'Añana un Psj, Dpto, interior, piso, Mz Lt',
        CODE: 'MX',
      },
      EC: {
        DNI: 'C.I. (Cédula de identidad)',
        CODE: 'EC',
      },
      COSTA_RICA: {
        DNI: 'C.I. (Cédula de identidad)',
        CODE: 'CR',
      },
    },
  },
  NOMBRE_EMPRESA: 'Molina Tours',
  PAGINACION: 5,
  PASARELA_PAGO: {
    CULQI: false,
    PAYU: false,
    OPENPAY: false,
    VISANET: false,
    OPENPAY_MERCHANT_ID: 'momgjkw3kuo80j584dge',
    OPENPAY_PUBLIC_KEY: 'pk_07276db5c8664cfdbb9faeb9da61da05',
    OPENPAY_SANDBOX: false,
    CULQI_SDK:false, // true solo somara
  },
  CONFIGURACIONES_PASARELAS: {
    VISANET: {
      MERCHANT_ID: '522591303',
      endPointJS:
        'https://static-content-qas.vnforapps.com/vToken/js/checkout.js',
      endPointSecurity:
        'https://apitestenv.vnforapps.com/api.security/v1/security',
      endPointSession:
        'https://apitestenv.vnforapps.com/api.ecommerce/v2/ecommerce/token/session/',
      endPointAuthorization:
        'https://apitestenv.vnforapps.com/api.authorization/v3/authorization/ecommerce/',
      currency: 'PEN',
      channel: 'web',
      user: 'integraciones.visanet@necomplus.com',
      pwd: 'd5e7nk$M',
      ruta_nexus: '',
    },
  },
  COLOR_ESTADO: {
    LIBRE: '#00e676',
    ASIGNADO: '#FF9800',
    LEIDO: '#ff5252',
    CONTACTO: '#5c6bc0',
    INICIO: '#3D5afe',
    LLEGO_DESTINO: '#ef9a9a',
    PENDIENTE: '#26a69a',
    RECHAZADO: '#D50000',
    OCUPADO: '#4c535a',
    FIN_JORNADA: '#21252921',
    PREASIGNADO: '#dc561d',
    ANULADO: '#adb5df',
    SIN_SENIAL: -1,
  },
  CENTER_MAP_COMPARTIR: {
    LAT: -12.1251109,
    LNG: -76.9928316,
    CITY: 'Salamanca',
    COUNTRY: 'PE',
    LOC: '-12.0833,-77.0000',
    REGION: 'Lima',
  },
  TARIFA_FORMA_CALCULO: {
    VALUE: 3,
    TEXT: 'Tarifa pactada Cliente- Conductor',
  },

  MONEDA: '(S/)',

  DOCUMENTO_FISCAL: {
    NOMBRE: 'RUC',
    DESCRIPCION: 'Razon Social',
  },
  CALIFICAR: {
    ACTIVO: false,
  },
  TEXTOS_ENVIOS: {
    PLACA: 'Económico',
    MONEDA: '$',
    VEHICULO: 'Vehículo',
  },

  APROBACIONES: {
    MSJ_APROBADO: 'El servicio fue aprobado.',
    MSJ_RECHAZADO: 'El servicio fue rechazado.',
    MSJ_APROBADO_ANTERIORMENTE: 'El servicio fue aprobado anteriormente.',
    MSJ_RECHAZADO_ANTERIORMENTE: 'El servicio fue rechazado anteriormente.',
    MSJ_PRE_APROBADO_ANTERIORMENTE: 'f.',
    MSJ_FECHA_EXPIRO: 'La fecha del servicio expiró.',
  },
  URL_FOTO_REPORTE: {
    URL: 'https://molinatours.nexusvirtual.net/',
    VALE: 'PhotoVale/',
    PEAJE: 'PhotoPeaje/',
    TEMPERATURA: 'https://assets-level.s3.amazonaws.com/FotoConductor/',
  },
  REGISTRO_USUARIO: false,
  OLVIDE_CONTRASENIA: true,
  TEXTO_SOLICITAR: {
    RESERVA: 'Reserva',
    INMEDIATO: 'Inmediato',
  },
  FLAG_SERVICIO_RUTINA: false,
  TIEMPO_SESION: {
    HABILITAR: true,
    TIEMPO: 120,
    PING: 60,
    TIMEOUT: 3600,
  },
  COUNTRY: 'PE',
  REPORTES_PERSONALIZADO: {
    HABILITADO: true,
    NOMBRE: 'MolinaToursReporteAuthorization',
  },
  REPORTES_PERSONALIZADO_PDF: {
    HABILITADO: false,
    NOMBRE: 'MolinaToursReporteAuthorization',
  },
  CONSULTAR_CONDUCTORES: true,
  ESTADO_CONDUCTORES: {
    SINGPS: 0,
    LIBRES: 1,
    OCUPADO: 2,
  },
  TIPO_VEHICULO_MAPS: {
    MOTO: 1,
    AUTO: 2,
  },
  //MOTO
  ISMOVICAB: false,
  ICONS: {
    MOTO: false,
    GAS: false,
  },
  MENU_VER_SERVICIOS: {
    VISUALIZAR_ICONO: {
      MOTO: false,
      CARRO: true,
      GAS: false,
    },
    OCULTAR_REFIN: false,
    OCULTAR_REFERENCIA: false,
  },
  REPORTE: {
    REPORTE_APROBACION: {
      FLAG_PREAPROBADOR: false, // TRUE SOLO LEVEL
      FLAG_NEW_APROBADOR: false, // TRUE SOLO LEVEL
    },
    FLAG_FACTURA:false
  },
  FLAG_COUNTRY_REGISTRO: false,
  SHOW_CONTAINER_REFIN: false,
  SHOW_CONTAINER_REFERENCIA: true,
  OBSERVACION: true,
  DATOS_CONTACTO: false,
  DATELLE_SERVICIO: true,
  ORIGEN_SERVICIO: true, //
  DESTINO_SERVICIO: true, // false solo en cargui
  SHOW_DATA_CONTACTO: false,
  DEFAULT_TIPO_PAGO_SERVICIO: true,
  FLAG_SERVICIO_RETORNO: true,
  SHOW_TIPO_VEHICULO: false, //SOLO ALO45
  //END MOTO
  //AEROPUERTO
  FLAG_AIRPORT: false,
  TIPO_VUELO: true,
  FAVORITOS: false, // SOLO DIRECTO EN TRUE
  //END AEROPUERTO
  //TRAKING
  URL_FOTO_CONDUCTOR: 'https://molinatours.nexusvirtual.net/photo/',
  URL_NOTIFICACIONES: 'https://reportes-docker.nexusvirtual.net/',
  PATH_TRACKING: '/molina-tracking/socket.io',

  TRUNC_DECIMAL: false,
  RUTA_DEFAULT: 'solicitar-servicio',
  FLAG_CLIENTE_ENCARGO: false,
  VERTRACKING: false,

  COMPANIA: false,
  VERIFICARDATOS: false,

  //PERSONALIZACION
  LABELS_PERSONALIZACION: config,
  CONFIGURATION: configuration,
  VALIDACIONES_SOLICITAR: {
    TRUNCAR_TOTAL_SERVICIO: true, // MOVICAB true
    RETORNO_ULTIMO_DESTINO: false, //MOVICAB TRUE and molinatours
    FLAG_RETORNO_RESERVA_INEDIATO: false, // solo CARGUI TRUE
    ULTIMO_DESTINO_TARIFAR_COMO_PRIMER_DESTINO: false, // solo MOVICAB TRUE
    INSTRUCCION_DESTINO: false, //MOVICAB TRUE
    REFERENCIA_DESTINO: true, //MOVICAB,MOLINA,NIREX TRUE
    CONTACTO_ADICIONAL: false, //MOVICAB TRUE
    AEROPUERTO_COMBO_NACIONAL_INTER: false,
    AEROPUERTO_DETALLES_VUELO: true,
    SELECCIONAR_TIPO_PAGO_DEFECTO: true, //MOVICAB false
    TIPO_VEHICULO: 'AUTO', //mOVICAB MOTO
    SOLICITAR_SERVICIO_RUTINA: true, //level true
    LISTAR_CODIGO_PROMOCIONAL: false, //TODOS FALSE
    MODAL_VERIFICACION_DATOS_SERVICIO: true, // solo level true
    OCULTARKM: true, //SOLO MOLINA TRUE
    CELULAR_CONTACTO: true, //TODOS TRUE}
    OBSERVACION: true, //SOLO NIREX FALSE
    SERVICIO_INMEDIADO: true, //NIREX FALSE
    AÑADIR_TARJETA: true, // SOLO NIREX
    DISPONE_TARJETA: true, // solo nirex
    FLAG_GA: false, // solo nirex
    HIDE_TOTAL_SERVICIO: true, // solo guaria false
    LISTA_PAGO_X_SERVICIO: false, //solo directo
    MOSTRAR_CARROS: false, //solo movicab
    FLAG_RESPUESTA: false, // solo nirex
    TIPO_PAGO_NIREX_DEFAULT: false, //solo nirex
    CONTACTO_X_MOTO: false, // solo level
    CONTACTO_X_COURIER: false, //solo level
    CANTIDAD_DESTINOS: 6, // normal 6 , nirex solo 8
    ACTIVAR_SEDES_MODAL_CARGA: false, //solo para altoke
    ACTIVAR_ICONO_VERSERVICIOS_GAS: false, //liligas
    CALCULAR_CANTIDAD_KM: false, // solo taxicorporativo
    ACTIVAR_ANCHO_CAJAS_SOLICITAR_SERVICIO: false, // true solo en cargui
    ACTIVAR_INMEDIATO_RESERVA_DESPACHADOR_AUTOMATICO: false, // true en CARGUI, DIRECTO, SR-TAXI
    MARKERS_CON_INFO_EN_MODAL: false, //treu solo directo
    FLAG_ANULAR_SERVICIO_INMEDIATO: false, // solo false en Remisse 21
    FLAG_PASAJEROS_POR_DESTINOS: false, //solo somara
    CAMPODINAMICO: {
      EFECTIVO: false, // true en cargui
    },
    FLAG_COLECTIVO_WEB: false, // true solo en directo,
    VALIDAR_PEDIR_PARA_OTROS: false, //true solo en directo
    FLAG_CODIGO_PROYECTO:false, // true en level
    FLAG_AEROPUERTO: false, // true en level
    FLAG_TEXAREA: false
  },
  VALIDACION_OWNER: {
    DIAS_DESCUENTO: false, //solo ivancar true
    MONTO_DESCUENTO: false, // solo ivancar true
    TOTAL_INCREMENTO_MONTO: false, // solo somara true
    TIEMPO_ESTIMADO_ENTREGA: true, // solo cargui true
    TIEMPO_EDICION: false, // cargui false
    FLAG_ACTIVACION_VISUALIZAR_TARIFA: false, // somara true
    FLAG_EMVIO_CORREO_FINALIZACION_SUPERVISOR: false, // solo directo en true
    FLAG_ACTIVO_DESES: false, // solo cargui
    FLAG_CORREO_HORIZONTAL:true // false solo Neway
  },
  VALIDACION_AGREGARUSUARIO: {
    HABILITAR_CAMPOS_CODIGO: false, // TRUE solo directo
  },
  CENTRO_COSTO_AREA: {
    COMBO: false, // solo para taxsat
  },
  TARIFA_X_BLOQUE: {
    ACTIVADO: false, // solo para nirex
  },
  PROVEEDOR_PASARELA: -1,
  DELIVERY: false,
  CODCLIENTE: 'NXVMOLINATOURS',
  POINT_GOOGLE_ANALYTICS: '',
  ICONO_TIPOSERVICIO: {
    URL_0: '',
    URL_1: '',
    //cargi
    URL_AUTO: '',
    URL_FURGON: '',
    URL_CAMION: '',
    URL_REFRIGERADO: '',
    ALT: '',
  },
  MOSTRAR_PROPINA: false, // solo para directo
  TIPO_REPORTE: [
    {
      id: 1,
      tipo: 'asistenciaConductor',
      filtros: {
        idConductor: true,
        tipoAsistencia: true,
        fechaInicio: true,
        fechaFin: true,
      },
    },
  ],
  ACTUALIZAR_DISEÑO_MONITOREO: true, // solo para cargui true,
  MONITOREO_CONDUCTORES: {
    BACKGROUND_COLOR: '#FFC713',
    COLOR: 'black',
  },
  USUARIO: {
    ACTIVAR_AREA: false, // solo sr taxi true
  },
  //PERSONALIZACION
  TEMEOUT_ALERT_MESSAGE: 5000,
  VALIDAR_GRUPO_NEGOCIO: {
    ACTIVO: false, // ACTIVO EN TRUE SOLO ALO45 Y MITAXI
    IDGRUPONEGOCIO: 0,
  },
};
/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
